import { ComponentsProps } from '@material-ui/core/styles/props';

const props: ComponentsProps = {
  MuiTextField: {
    variant: 'outlined'
  },
  MuiFormControl: {
    variant: 'outlined'
  },
  MuiSelect: {
    variant: 'outlined'
  },
  MuiListSubheader: {
    color: 'primary',
    disableSticky: false,
    disableGutters: false,
  },
  MuiCard: {
    elevation: 3
  },
  MuiPaper: {
    elevation: 3
  },
  MuiList: {
    disablePadding: true
  },
  MuiDialogContent: {
    dividers: true
  },
  MuiIconButton: {
    size: 'small'
  },
  MuiContainer: {
    disableGutters: true,
    maxWidth: 'xl'
  },
  MuiGrid: {
    spacing: 1
  },
  MuiCardHeader: {
    titleTypographyProps: {
      color: 'primary',
      variant: 'h6'
    }
  },
  MuiLink: {
    underline: 'always'
  }
};

export default props;